
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ApplicationStatusBadge } from "./ApplicationStatusBadge";

export const getApplicationColumns = () => {
  const navigate = useNavigate();
  
  return [
    {
      accessorKey: "id",
      header: "Application ID",
    },
    {
      accessorKey: "borrower_name",
      header: "Borrower",
    },
    {
      accessorKey: "amount",
      header: "Amount Requested",
      cell: ({ row }) => {
        const amount = parseFloat(row.getValue("amount"));
        const formatted = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(amount);
        return formatted;
      },
    },
    {
      accessorKey: "credit_score",
      header: "Credit Score",
    },
    {
      accessorKey: "application_date",
      header: "Date Applied",
    },
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ row }) => <ApplicationStatusBadge status={row.getValue("status")} />,
    },
    {
      accessorKey: "actions",
      header: "Actions",
      cell: ({ row }) => {
        const status = row.getValue("status");
        const id = row.getValue("id");
        return (
          <div className="flex gap-2">
            <Button 
              variant="outline" 
              size="sm"
              onClick={() => navigate(`/lender/loans/applications/${id}`)}
            >
              View
            </Button>
            {status === "pending" || status === "review" ? (
              <Button 
                variant="default" 
                size="sm"
                onClick={() => navigate(`/lender/loans/applications/${id}/review`)}
              >
                Review
              </Button>
            ) : null}
          </div>
        );
      },
    },
  ];
};
